var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLandConstruction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#FFF1CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0417 29.1739H30.5056C30.2437 29.1739 30.0691 28.9993 30.0691 28.7373C30.0691 28.4754 30.2437 28.3008 30.5056 28.3008H34.0417C34.3036 28.3008 34.4782 28.4754 34.4782 28.7373C34.4782 28.9993 34.3036 29.1739 34.0417 29.1739Z",
    fill: "#1E1548"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4523 31.7871H10.9974C10.6645 31.7871 10.3603 31.9756 10.212 32.2736L5.63064 41.4842C5.34058 42.0673 5.76474 42.752 6.41604 42.752H53.5171C54.1841 42.752 54.6071 42.037 54.2858 41.4524L49.2245 32.2419C49.0704 31.9614 48.7758 31.7871 48.4557 31.7871H46.1389",
    fill: "#92C281"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8245 34.043H12.3203L8.86401 41.2102H50.6243L47.0571 34.043H44.6887",
    stroke: "white",
    strokeWidth: 0.657895,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.39 2.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8427 38.76H42.0716C42.3061 38.76 42.4624 38.6037 42.4624 38.3692C42.4624 38.1347 42.3061 37.9784 42.0716 37.9784H41.251V32.4683C41.251 32.2338 41.0947 32.0775 40.8602 32.0775H39.297V21.4089H39.6878C39.9223 21.4089 40.0786 21.2526 40.0786 21.0182V19.3378H41.9935C42.228 19.3378 42.3843 19.1814 42.3843 18.947V16.6804C42.3843 16.4459 42.228 16.2896 41.9935 16.2896H40.0786V15.3908C40.0786 15.1563 39.9223 15 39.6878 15H35.2719C35.0374 15 34.8811 15.1563 34.8811 15.3908V15.977H23.8218C23.7045 15.977 23.5873 16.0161 23.5482 16.0942L20.6955 18.947C20.5782 19.0642 20.5391 19.2205 20.6173 19.3768C20.6955 19.5332 20.8127 19.6113 20.969 19.6113H23.431V22.425L17.7645 26.5674C17.6473 26.6846 17.5691 26.8409 17.6082 26.9972C17.6473 27.1536 17.8036 27.2708 17.999 27.2708H29.6836C29.8399 27.2708 29.9962 27.1536 30.0744 26.9972C30.1135 26.8409 30.0744 26.6455 29.9181 26.5674L24.2126 22.425V19.6504H34.8811V21.0572C34.8811 21.2917 35.0374 21.448 35.2719 21.448H35.6236V32.1166H34.0605C33.826 32.1166 33.6697 32.2729 33.6697 32.5074V38.0175H28.5112V29.4592C28.5112 29.2247 28.3549 29.0684 28.1205 29.0684H19.5231C19.2886 29.0684 19.1323 29.2247 19.1323 29.4592V37.9784H17.8427C17.6082 37.9784 17.4519 38.1347 17.4519 38.3692C17.4519 38.6037 17.6082 38.76 17.8427 38.76ZM40.0396 17.0711H41.5637V18.5952H40.0396V17.0711ZM32.6145 16.7976L34.8811 18.478V16.7976H32.6145ZM30.3088 16.7585L28.0423 18.4388V16.7585H30.3088ZM24.9941 16.7976L27.2607 18.478V16.7976H24.9941ZM23.4309 18.8689H21.9068L23.4309 17.3448V18.8689ZM23.8218 23.0894L19.1714 26.4893H28.4722L23.8218 23.0894ZM24.2125 17.1493L26.479 18.8297H24.2125V17.1493ZM31.0905 17.1885L28.8239 18.8689H31.0905V17.1885ZM31.872 17.1493L34.1386 18.8297H31.872V17.1493ZM36.4051 21.4089V32.0775H38.4763V21.4089H36.4051ZM22.2587 37.9784V35.3211C22.2587 34.4613 22.9621 33.7579 23.8218 33.7579C24.6816 33.7579 25.385 34.4613 25.385 35.3211V37.9784H22.2587ZM40.4693 32.8591H34.4512V37.9784H40.4693V32.8591Z",
    fill: "#120136"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0352 28.2773H29.1229V38.8037H27.1053V35.3624C27.1053 33.6923 25.7435 32.3259 24.079 32.3259C22.4145 32.3259 21.0527 33.6923 21.0527 35.3624V38.8037H19.0352C19.0352 38.8037 19.0352 28.2773 19.0352 28.2773Z",
    fill: "#FFDC53"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2585 37.9783V35.321C22.2585 34.4612 22.962 33.7578 23.8217 33.7578C24.6814 33.7578 25.3849 34.4612 25.3849 35.321V37.9783H22.2585Z",
    fill: "#120136"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4519 31.8379H41.3466V37.9782H33.4519V31.8379Z",
    fill: "#120136"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6628 15.7812H39.2581V20.627H35.6628V15.7812V15.7812Z",
    fill: "#97AFCE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4062 32.0768V21.4082H39.3536V32.0768H35.4062Z",
    fill: "#120136"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3314 31.8898H21.1446C20.9669 31.8898 20.7893 31.7477 20.7893 31.5346V31.499V31.4635V29.5096C20.7893 29.2964 20.9314 29.1543 21.1446 29.1543H26.3314C26.4025 29.1543 26.4735 29.1898 26.5446 29.2253C26.6867 29.2609 26.7933 29.403 26.7933 29.5451V31.4635C26.7933 31.6411 26.6511 31.7832 26.509 31.8188C26.4735 31.8543 26.4025 31.8898 26.3314 31.8898ZM25.0879 31.1793H26.1182V29.8649H25.0879V31.1793ZM24.3419 31.1793H23.2761V29.8649H24.3419V31.1793ZM21.4999 31.1793H22.5657V29.8649H21.4999V31.1793Z",
    fill: "#1E1548"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5658 31.1797H21.5V29.8652H22.5658V31.1797Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3419 31.1797H23.2761V29.8652H24.3419V31.1797Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1182 31.1797H25.0879V29.8652H26.1182V31.1797Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4036 27.3999L23.8597 22.1367L31.3158 27.3999H16.4036Z",
    fill: "#B55436"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8596,
    cy: 24.7678,
    r: 0.877193,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8218 26.0986C23.1965 26.0986 22.6885 25.5906 22.6885 24.9653C22.6885 24.3401 23.1965 23.832 23.8218 23.832C24.447 23.832 24.9551 24.3401 24.9551 24.9653C24.9551 25.5906 24.447 26.0986 23.8218 26.0986ZM24.1735 24.9654C24.1735 24.77 24.0172 24.6137 23.8218 24.6137C23.6264 24.6137 23.4701 24.77 23.4701 24.9654C23.4701 25.1608 23.6264 25.3171 23.8218 25.3171C24.0172 25.3171 24.1735 25.1608 24.1735 24.9654Z",
    fill: "#1E1548"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLandConstruction);
export default __webpack_public_path__ + "static/media/icon-land-construction.34527acce9cdc7bf908181402c35eaba.svg";
export { ForwardRef as ReactComponent };